import React from 'react';
import { usePopup } from '../context/PopupContext';
import { Button } from './ui/button';

const PopupButton = ({ children, className, ...props }) => {
  const { openPopup } = usePopup();

  const handleClick = (e) => {
    e.preventDefault();
    openPopup();
  };

  return (
    <Button onClick={handleClick} className={className} {...props}>
      {children}
    </Button>
  );
};

export default PopupButton;
